export default __webpack_public_path__ + "static/media/bridgeFrom.5a529f99.svg";